import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <main style={{ padding: '4rem 1rem', textAlign: 'center' }}>
    <h1>Page not found</h1>
    <p><Link to="/">Back to home</Link></p>
  </main>
);

export default NotFound;
